module.exports = __webpack_public_path__ + "img/icon-customer-waitlist.ab6b1731.svg";